export default __webpack_public_path__ + "static/ta_logo-089120b06a930dfa83f3a0bfa943b685.png";